<template>
  <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
      <FormItem label="原始密码" prop="oripwd">
      <Input type="password" v-model="formCustom.oripwd" @on-change="showtips=false"></Input>
    </FormItem>
    <FormItem label="新设密码" prop="newpwd">
      <Input type="password" v-model="formCustom.newpwd" @on-change="showtips=false"></Input>
    </FormItem>
    <FormItem label="密码确认" prop="pwdcheck">
      <Input type="password" v-model="formCustom.pwdcheck" @on-change="showtips=false"></Input>
    </FormItem>
    <FormItem>
 <!--      <Alert type="warning" show-icon :style="{display: showtips?'block':'none'}">
        <span slot="desc">您所提交的信息有误,请重新输入 </span>
      </Alert> -->
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: 'editPwdSubmit',
  data() {

    const checkoripwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原始密码'));
      }else if(value.length < 6){
        callback(new Error(this.pwdrule));
      }else {
        callback();
      }
    }

    const checknewpwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新设密码'));
      } else if(value.length < 6){
        callback(new Error(this.pwdrule));
      }else {
        callback();
      }
    }
    const checknewpwdagain = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error(this.pwdrule));
      }
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value !== this.formCustom.newpwd) {
        callback(new Error('两次密码输入不一致'));
      } else {
        callback();
      }
    }
    return {
      formCustom: {
        oripwd:'',
        newpwd: '',
        pwdcheck: '',
      },
      ruleCustom: {
        oripwd: [
          { validator: checkoripwd, trigger: 'blur' }
        ],
        newpwd: [
          { validator: checknewpwd, trigger: 'blur' }
        ],
        pwdcheck: [
          { validator: checknewpwdagain, trigger: 'blur' }
        ],
      },
      showtips: false,
      pwdrule: '密码长度至少6位',
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.showtips = false;
           this.$emit('onEditPwd',this.formCustom);
        } else {
          //this.$Message.error('Fail!');
          this.showtips = true;
        }
      })
    },
    handleReset(name) {
      //console.log(22222)
      this.$refs[name].resetFields();
      this.showtips = false;
    },
  }
}
</script>
<style>
</style>
